import { cx } from "@linaria/core";
import { useRef } from "react";

import * as styles from "./_slider.style";
import { Caption } from "./atom.caption";
import { Scrambled } from "./atom.scrambled";
import { CarouselSlider } from "./organism.carousel/_carousel";
import {
  SingularSlider,
  SliderComponentSelector,
} from "./organism.slider/_slider";
import { SliderModel } from "@courses-pm2/api";
import { resets, textColumnCls } from "@pm2/compat";

type Props = {
  model: SliderModel;

  onDragStart?(): void;
  onDragEnd?(): void;
};

export function SliderComponent(props: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  if (props.model.isScrambled) {
    return <Scrambled />;
  }

  if (props.model.slides.length === 0) {
    // unable to render completely empty slides; they don't really make any
    // sense either so assume that they work
    return null;
  }

  const displayCaption = !!props.model.displayCaption;

  const content = (() => {
    switch (props.model.displayType) {
      case "carousel":
        return <CarouselSlider {...props} displayCaption={displayCaption} />;

      default:
        return (
          <SingularSlider
            model={props.model}
            displayCaption={displayCaption}
            onDragStart={props.onDragStart}
            onDragEnd={props.onDragEnd}
          />
        );
    }
  })();

  return (
    <section
      ref={containerRef}
      className={cx("gSlider", styles.container, resets.rootCls)}
      data-component-type={SliderComponentSelector}
    >
      <header className={cx(styles.header, textColumnCls)}>
        <div className={styles.headerText}>
          {props.model.title && (
            <h4 className={styles.heading}>{props.model.title}</h4>
          )}

          {displayCaption && <Caption caption={props.model.caption} />}
        </div>
      </header>

      {content}
    </section>
  );
}
